module.exports = __webpack_public_path__ + "media/images/p21-29247313.svg";